/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */

var PREVIEW_PANEL_INDICATORS = {
  EMBEDDED_SOURCE: 'embeddedConfluenceSource',
  PREVIEW_PANELS: 'previewPanels',
  CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
var getUrlSearchParams = function getUrlSearchParams(url) {
  try {
    return new URLSearchParams(url);
  } catch (_unused) {
    return null;
  }
};
var hasPreviewPanelIndicators = function hasPreviewPanelIndicators(searchParams) {
  return searchParams.has(PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get(PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};

/**
 * Checks if the current code is running inside an iframe.
 * @returns true if running in an iframe, false otherwise
 */
export var isInIframe = function isInIframe() {
  try {
    return window !== window.top;
  } catch (_unused2) {
    // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
    return true;
  }
};

/**
 * Checks if the current context is within a preview panel.
 * This is determined by checking for specific URL parameters:
 * - previewPanels parameter
 * - embeddedConfluenceSource=confluence-page-preview-panel
 */
export var isWithinPreviewPanel = function isWithinPreviewPanel() {
  try {
    var currentSearch = window.location.search;
    if (currentSearch) {
      var currentParams = getUrlSearchParams(currentSearch);
      if (currentParams && hasPreviewPanelIndicators(currentParams)) {
        return true;
      }
    }
    return false;
  } catch (_unused3) {
    return false;
  }
};

/**
 * Checks if a modal is being displayed within a preview panel iframe.
 * This is useful for components that need to adjust their behavior when
 * rendered inside a preview panel (e.g., hiding certain UI elements).
 * @returns true if in an iframe AND within a preview panel, false otherwise
 */
export var isWithinPreviewPanelIFrame = function isWithinPreviewPanelIFrame() {
  return isInIframe() && isWithinPreviewPanel();
};